import {
  GET_CALENDAR,
  POST_CALENDAR,
  LOADING_CALENDAR
} from "../Actions/types";

const initialState = {
  offDays: [],
  loading_calendar: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOADING_CALENDAR:
      return {
        ...state,
        loading_calendar: true,
      };
    case GET_CALENDAR:
      return {
        ...state,
        offDays: action.payload,
        loading_calendar: false
      };
    case POST_CALENDAR:
      return {
        ...state,
        offDays: action.payload,
        loading_calendar: false
      };
    default:
      return state;
  }
}
